import React from 'react';
import { DeleteConfirmModal } from '../../../components/generic/DeleteConfirmModal';
import { createModal } from '../../../components/generic/Modal';
import { useDeleteIncidentCategoryMutation } from '../../../graphql/hooks/useDeleteIncidentCategoryMutation';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  categoryId: string;
  categoryName: string;
}

export const IncidentCategoryDeleteModal = createModal<Props>((props) => {
  const { categoryId, categoryName, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteIncidentCategoryMutation({});

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        categoryId,
      })
      .then(async () => {
        successToast('Incident category deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting incident category: ${err.message}`);
      });
  }, [mutation, organization, categoryId, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this incident category?'
      confirmation={{ level: 'Level2', confirm: categoryName }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
